import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inviteEvaluators: {
    id: `app.containers.ScorecardModals.inviteEvaluators`,
    defaultMessage: 'Invite evaluators',
    description: 'Title of the modal for inviting scorecard evaluators',
  },
  yourScorecard: {
    id: `app.containers.ScorecardModals.yourScorecard`,
    defaultMessage: 'Your scorecard',
    description:
      'Tag on the results table column holding the signed-in evaluator',
  },
  invitedDate: {
    id: `app.containers.ScorecardModals.invitedDate`,
    defaultMessage: 'Invited {date}',
    description:
      'Date under an evaluator who has not submitted their scorecard yet',
  },
  showMore: {
    id: `app.containers.ScorecardModals.showMore`,
    defaultMessage: 'Show more',
    description: 'Toggle that expands a clamped scorecard note',
  },
  showLess: {
    id: `app.containers.ScorecardModals.showLess`,
    defaultMessage: 'Show less',
    description: 'Toggle that collapses an expanded scorecard note',
  },
  resultsLoadFailed: {
    id: `app.containers.ScorecardModals.resultsLoadFailed`,
    defaultMessage:
      "We couldn't load the scorecard results. Refresh the page or try again later.",
    description: 'Error shown when the scorecard results fail to load',
  },
  inviteIntro: {
    id: `app.containers.ScorecardModals.inviteIntro`,
    defaultMessage:
      'Invite evaluators to score {applicantName} with the {scorecardName} scorecard',
    description:
      'Line under the invite evaluators modal title naming the applicant and the scorecard',
  },
  assignedEvaluators: {
    id: `app.containers.ScorecardModals.assignedEvaluators`,
    defaultMessage: 'Assigned evaluators',
    description:
      'Label over the list of evaluators already on the scorecard in the invite modal',
  },
  evaluatorsLabel: {
    id: `app.containers.ScorecardModals.evaluatorsLabel`,
    defaultMessage: 'Evaluators',
    description: 'Label on the user search input in the invite modal',
  },
  searchUsersPlaceholder: {
    id: `app.containers.ScorecardModals.searchUsersPlaceholder`,
    defaultMessage: 'Search Fountain users by name...',
    description: 'Placeholder of the user search input in the invite modal',
  },
  noUsersMatch: {
    id: `app.containers.ScorecardModals.noUsersMatch`,
    defaultMessage: 'No Fountain users match',
    description: 'Empty state of the user search dropdown in the invite modal',
  },
  onlyExistingUsers: {
    id: `app.containers.ScorecardModals.onlyExistingUsers`,
    defaultMessage:
      'Only existing Fountain users can be invited as evaluators.',
    description:
      'Second line of the user search empty state in the invite modal',
  },
  sendInvitation: {
    id: `app.containers.ScorecardModals.sendInvitation`,
    defaultMessage: 'Send invitation',
    description:
      'Primary button of the invite modal with one evaluator selected',
  },
  sendInvitations: {
    id: `app.containers.ScorecardModals.sendInvitations`,
    defaultMessage: 'Send invitations',
    description:
      'Primary button of the invite modal with several evaluators selected',
  },
  invitationsSent: {
    id: `app.containers.ScorecardModals.invitationsSent`,
    defaultMessage: 'Invitations sent',
    description: 'Heading of the invite modal success state',
  },
  invitationsSentDetail: {
    id: `app.containers.ScorecardModals.invitationsSentDetail`,
    defaultMessage:
      '{count, plural, one {# evaluator} other {# evaluators}} will receive a scorecard invitation.',
    description: 'Body of the invite modal success state',
  },
  submittedDate: {
    id: `app.containers.ScorecardModals.submittedDate`,
    defaultMessage: 'Submitted {date}',
    description:
      'Date under an evaluator who submitted, in the invite modal assigned list',
  },
  statusSubmitted: {
    id: `app.containers.ScorecardModals.statusSubmitted`,
    defaultMessage: 'Submitted',
    description: 'Status tag on an evaluator who submitted their scorecard',
  },
  statusDraft: {
    id: `app.containers.ScorecardModals.statusDraft`,
    defaultMessage: 'Draft',
    description: 'Status tag on an evaluator holding a draft scorecard',
  },
  statusPending: {
    id: `app.containers.ScorecardModals.statusPending`,
    defaultMessage: 'Pending',
    description:
      'Status tag on an evaluator who has not started their scorecard',
  },
  evaluatorActions: {
    id: `app.containers.ScorecardModals.evaluatorActions`,
    defaultMessage: 'Evaluator actions',
    description:
      'Accessible label of the three-dot menu on an assigned evaluator row',
  },
  sendReminder: {
    id: `app.containers.ScorecardModals.sendReminder`,
    defaultMessage: 'Send reminder',
    description: 'Row menu action that nudges an assigned evaluator',
  },
  reminderSent: {
    id: `app.containers.ScorecardModals.reminderSent`,
    defaultMessage: 'Reminder sent to {name}.',
    description: 'Confirmation shown after a reminder email is sent',
  },
  reminderFailed: {
    id: `app.containers.ScorecardModals.reminderFailed`,
    defaultMessage: "We couldn't send the reminder. Try again.",
    description: 'Error shown when sending a reminder fails',
  },
  removeEvaluator: {
    id: `app.containers.ScorecardModals.removeEvaluator`,
    defaultMessage: 'Remove evaluator',
    description: 'Row menu action that takes an evaluator off the scorecard',
  },
  removeEvaluatorFailed: {
    id: `app.containers.ScorecardModals.removeEvaluatorFailed`,
    defaultMessage: "We couldn't remove the evaluator. Try again.",
    description: 'Error shown when removing an evaluator fails',
  },
  noManagePermission: {
    id: `app.containers.ScorecardModals.noManagePermission`,
    defaultMessage:
      "You don't have permission to manage evaluators. Contact your admin to request access.",
    description:
      'Notice in the invite modal body for a user who can only view the applicant',
  },
  searchFailed: {
    id: `app.containers.ScorecardModals.searchFailed`,
    defaultMessage: "We couldn't search users. Try again.",
    description:
      'Error shown in the invite modal dropdown when the user search fails',
  },
  evaluatorsLoadFailed: {
    id: `app.containers.ScorecardModals.evaluatorsLoadFailed`,
    defaultMessage:
      "We couldn't load the assigned evaluators. Refresh the page or try again later.",
    description: 'Error shown when the assigned evaluators fail to load',
  },
  inviteFailed: {
    id: `app.containers.ScorecardModals.inviteFailed`,
    defaultMessage: "We couldn't send the invitations. Try again.",
    description: 'Error shown when sending evaluator invitations fails',
  },
  advanceAfterSubmitNotice: {
    id: `app.containers.ScorecardModals.advanceAfterSubmitNotice`,
    defaultMessage:
      'Status label saved. This stage requires a scorecard before the applicant can advance. Submit it to continue.',
    description:
      'Notice atop the scorecard form when completing the last status label would advance the applicant but the stage requires a scorecard first',
  },
});
